import { ComponentRef, Directive, inject, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { DynamicComponentConfig } from './dynamic-component-host-config';

@Directive({
  selector: '[appDynamicComponentHost]',
  standalone: true
})
export class DynamicComponentHostDirective implements OnInit, OnDestroy {
  @Input() dynamicComponent: DynamicComponentConfig<any>;

  private factory: ComponentRef<any>;

  private viewContainerRef = inject(ViewContainerRef);

  ngOnInit(): void {
    this.factory = this.viewContainerRef.createComponent(this.dynamicComponent.componentType);

    if (this.dynamicComponent.data) {
      Object.entries(this.dynamicComponent.data)
        .forEach(([key, value]) => this.factory.setInput(`${key}`, value));
    }

    if (this.dynamicComponent.resolve) {
      Object.entries(this.dynamicComponent.resolve)
        .forEach(([key, value]) => this.factory.setInput(`${key}`, value()));
    }

    if (this.dynamicComponent.onInit) {
      this.dynamicComponent.onInit(this.factory.instance);
    }
  }

  ngOnDestroy(): void {
    this.factory.destroy();
  }
}